//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// page
import Header from "../../component/common/Header";
import SignUp from "./components/SignUp";
import Footer from "../../component/common/Footer";
import InnerCon from "../../component/layouts/InnerCon";

// component
import DefaultModal from "../../component/popup/DefaultModal";

export default function SignUpPage() {
    // 1. 없는 추천인 아이디 적었을때 팝업
    const [recommModal, setRecommModal] = useState(false);
    // 2. 이용약관 다 동의 안했을때 팝업
    const [agreeModal, setAgreeModal] = useState(false);

    return (
        <Wrap>
            <Header />
            <InnerCon>
                <SignUp setRecommModal={setRecommModal} setAgreeModal={setAgreeModal} />
            </InnerCon>
            <Footer />

            {/* 1. 없는 추천인 아이디 적었을때 팝업 */}
            {recommModal && <DefaultModal closeModal={() => setRecommModal(false)} Simple={true} text="등록되지않은 추천인 ID 입니다." />}

            {/* 2. 이용약관 다 동의 안했을때 팝업 */}
            {agreeModal && <DefaultModal closeModal={() => setAgreeModal(false)} Simple={true} text="필수이용약관에 동의해주세요." />}
        </Wrap>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;
`;
